// Generated by purs version 0.15.15
import * as $foreign from "./foreign.js";

export {
    unit
} from "./foreign.js";
